export default __webpack_public_path__ + "static/avatar-01-4efd09e7a1193a9ee8698378a36ceb5d.svg";